// extracted by mini-css-extract-plugin
export var arrow = "bg_dp";
export var profile = "bg_dn";
export var text = "bg_c5";